import { render, staticRenderFns } from "./GenotypeExportModal.vue?vue&type=template&id=1271dd2a&"
import script from "./GenotypeExportModal.vue?vue&type=script&lang=js&"
export * from "./GenotypeExportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports